class CollectionModelSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  handleClick = (event) => {
    const option = event.target.closest("[data-filter-param]");
    if (!(option instanceof HTMLAnchorElement)) return;

    event.preventDefault();

    const parameter = option.dataset.filterParam;
    if (!parameter) return;

    const url = new URL(window.location.href);
    const selectedValue =
      option.dataset.filterActive === "true"
        ? ""
        : (option.dataset.filterValue ?? "");

    url.searchParams.delete(parameter);
    url.searchParams.delete("page");

    if (parameter === "filter.p.vendor") {
      const modelParameter = this.dataset.modelParam;
      if (modelParameter) url.searchParams.delete(modelParameter);
    }

    if (selectedValue) url.searchParams.append(parameter, selectedValue);

    window.location.assign(url.toString());
  };
}

if (!customElements.get("collection-model-selector")) {
  customElements.define("collection-model-selector", CollectionModelSelector);
}
